import { render } from "./BovineServicesCard.vue?vue&type=template&id=580852e1&scoped=true"
import script from "./BovineServicesCard.vue?vue&type=script&lang=js"
export * from "./BovineServicesCard.vue?vue&type=script&lang=js"

import "./BovineServicesCard.vue?vue&type=style&index=0&id=580852e1&lang=scss&scoped=true"

import exportComponent from "/home/elias/web-farm/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-580852e1"]])

export default __exports__